import vuetifyToast from 'vuetify-toast'
import { baseActions, baseMutations } from '../base'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'
const notify = (message, type) => {
  vuetifyToast.show({
    text: message,
    color: type || 'success',
    timeout: 5000,
    icon: 'check',
  })
}
const initialState = () => {
  return {
    module: 'rbpi',
    model: 'rbpi',
    loading: false,
    list: [],
    selectList: [],
    rbpiStatus: [],
    selected: {
      active: true,
      name: '',
      description: '',
      path: '',
      apiKey: '',
      stadiumId: '',
    },
    idSelected: '',
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 0,
      totalItems: 10,
    },
  }
}

const state = initialState()

const getters = {
  selectList(state) {
    return state.selectList
  },
  formatedList(state) {
    return state.list.map((item) => {
      let result = {
        _id: item._id,
        active: item.active,
        name: item.name,
        description: item.description,
        status: item.status,
        stadium: item.stadiumId ? item.stadiumId.name : '-',
        createdAt: formatDate(item.createdAt, true),
        createdBy: item.createdBy
          ? item.createdBy.name + ' ' + item.createdBy.lastname1
          : '-',
      }
      return result
    })
  },
}

const actions = {
  ...baseActions,
  async fetchList({ dispatch, commit, state, rootState }, params = {}) {
    let query = {
      page: state.pagination.page,
      limit: state.pagination.rowsPerPage,
    }
    let body = Object.assign({}, params)
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    if (body.page) {
      query.page = body.page
      delete body.page
    }

    if (rootState.stadiums.idSelected) {
      body.stadiumId = rootState.stadiums.idSelected
      dispatch('fetchSelectList', {
        stadiumId: rootState.stadiums.idSelected,
        limit: 0,
      })
    }
    if (state.selected.active !== undefined) body.active = 'all'
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module, body, { params: { ...query } })
      .finally(() => commit('setLoading', false))
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setPagination', {
      totalItems: data.paginate ? data.paginate.totalData : 0,
    })
    commit('setList', list)
  },
  async fetchRbpiStatus({ commit }, rbpiId) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`rbpi/${rbpiId}/rbpiStatus`)
      .finally(() => commit('setLoading', false))
    const list = data.data ? data.data.rbpiStatus : []
    commit('setRbpiStatus', list)
    return list
  },
  async checkRBPIStatus(conext, params) {
    const { data } = await apiAxios.post(`rbpi/checkRBPIStatus`, params)
    return data.data
  },
  async getBackUpVideo(conext, params) {
    const { data } = await apiAxios.post(`uga/video-recovery`, params)
    notify(data.message)
    return data.data
  },
}

const mutations = {
  ...baseMutations,
  setRbpiStatus(state, payload) {
    state.rbpiStatus = []
    if (Array.isArray(payload)) {
      payload.forEach((item) => state.rbpiStatus.push(item))
    }
  },
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
